export default {
  dictionary: {
    producthub: 'Scaleflow',
    loading: 'Loading',
    expected: 'Expected',
    returns:
      '{num, plural, =0 {Return on investment} =1 {Return on investment} other {Returns}}',
    investment:
      '{num, plural, =0 {Capital investment} =1 {Capital investment} other {Capital investments}}',
    impact: 'Financial impact',
    product: 'Portfolio',
    help: 'Help',
    roles: '{num, plural, =0 {Function} =1 {Function} other {Functions}}',
    initiatives:
      '{num, plural, =0 {No Project to display} =1 {Project} other {Projects}}',
    case: 'Case',
    weeks: '{num, plural, =0 {No weeks} =1 {Week} other {Weeks}}',
    view: 'View',
    edit: 'Edit',
    fte: 'FULL-TIME EQUIVALENT',
    delete: 'Delete',
    'person-weeks': 'Team member-weeks',
    to: 'to',
    from: 'from',
    title: 'Title',
    'choose-date': 'Choose a date',
    filters: 'Search filters',
    in: 'in',
    goals:
      '{num, plural, =0 {Strategic objective} =1 {Strategic objective} other {Strategic objectives}}',
    save: 'Save',
    'save-and-close': 'Save & Close',
    saved: 'Saved',
    confidence: 'confidence level',
    abbreviation: 'abbreviation',
    'group-by': 'Group by',
    'breakout-by': 'Breakout by',
    'sort-by': 'Sort by',
    name: 'Name',
    person:
      '{num, plural, =0 {Team member} =1 {team member} other {team members}}',
    'do-later': 'Feel free to do this later',
    team: '{num, plural, =0 {Team} =1 {Team} other {Teams}}',
    active: 'Under development',
    inactive: 'Inactive',
    cancel: 'Cancel',
    themes: '{num, plural, =0 {Tag} =1 {Tag} other {Tags}}',
    source:
      '{num, plural, =0 {Project source} =1 {Project source} other {Project sources}}',
    status: 'Development status',
    'start-date': 'Start date',
    'end-date': 'Commercial operation',
    'back-of-napkin':
      '{num, plural, =0 {Financial impact} =1 {Financial impact} other {Financial impact}}',
    details: 'Details',
    'close-panel': 'Close panel',
    'close-menu': 'Clone menu',
    select: 'Select',
    selected: 'Selected',
    search: 'Search',
    'search-for-attribute': 'Search for {attribute}',
    roadmap: '{num, plural, =0 {Pipeline} =1 {Pipeline} other {Pipelines}}',
    'show-grouping': 'Show grouping',
    no: 'No',
    calculate: 'Calculate',
    approximately: 'approximately',
    settings: 'Configuration',
    'add-to-favorites': 'Add to favourites',
    unfavorite: 'Remove from favourites',
    favorites: 'Favorites',
    uncertainty:
      '{num, plural, =0 {Risk factor} =1 {Risk factor} other {Risk factors} }',
    edited: 'Edited',
    show: 'Show',
    info: 'Info',
    notes: 'Notes',
    add: 'Add',
    value: 'Value',
    explanation: 'Explanation',
    'add-item': 'Add item',
    'show-archive-of': 'Show archive of',
    unfiled: 'Unfiled',
    'danger-zone': 'Danger zone',
    'close-archive': 'Close archive',
    empty: 'No items inactive',
    restore: 'Restore',
    'tap-to-edit': 'Tap to edit',
    author: 'author',
    'add-to-attribute': 'Add to {attribute}',
    'add-a-attribute': 'Add a {attribute}',
    bookmark: '{num, plural, =0 {Favorites} =1 {Favorites} other {Favorites} }',
    'bookmarks-nav-description': 'Manage external links ',
    icon: 'Icon',
    url: 'URL',
    'capacity-fte': 'Capacity (FULL-TIME EQUIVALENT)',
    optional: 'optional',
    archived: 'Inactive',
    archive: 'Historical records',
    links: '{num, plural, =0 {Link} =1 {Link} other {Links} }',
    unlink: 'Unlink',
    'archive-checked-items': 'File checked items',
    'log-out': 'Log out',
    'clear-selection': 'Clear selection',
    eligible: 'Eligible',
    'out-of': 'out of',
    pm: '{num, plural, =0 {Lead} =1 {Lead} other {Leads}}',
    'unsaved-changes': 'You have unsaved changes',
    capacity: ' Capacity',
    total: 'Total',
    options: '{num, plural, =0 {option} =1 {option} other {options}}',
    default: 'Default',
    roi: 'Projects',
    created: 'Created',
    'created-at': 'Created at',
    create: 'Create',
    ago: 'ago',
    comments: '{num, plural, =0 {note} =1 {note} other {notes}}',
    drag: 'Drag',
    collapse: 'Collapse',
    expand: 'Expand',
    more: 'more',
    less: 'less',
    unspecified: 'Unspecified',
    'go-back': 'Go back',
    prev: 'Prev',
    next: 'Next',
    update: 'Update',
    overview: 'Summary',
    matrix: 'Matrix',
    for: 'for',
    column: 'Column',
    row: 'Row',
    strategy: 'Investment strategy',
    effort: 'Resource allocation',
    'waiting-for-answers': 'Blockers',
    horizon: 'Investment horizon',
    or: 'or',
    here: 'here',
    duration: 'Timeline',
    organisation: 'Company',
    financials: 'Economics',
    'contact-email': 'mailto:project team@scaleflow.com',
    insights: 'Insights',
    'open-menu': 'Open main menu',
    operations: 'Operations & maintenance',
    grid: 'Status',
    lanes: 'Pipeline view',
    'quick-links': 'Quick links',
    timeline: 'Schedule view',
    'progress-overview': 'Status summary',
    reported: 'Reported',
    'last-updated': 'Last updated',
    'type-delete-to-confirm': 'Please type "delete" to confirm',
    'progress-hint': 'Please select a development status to save your update',
    authenticating: 'Authenticating',
    date: 'Date',
    metrics: 'KPIs',
    all: 'All',
    'hide-column': 'Hide column',
    grouping: 'Grouping',
    sorting: 'Sorting',
    visibility: 'Visibility',
    filtering: 'Filtering',
    new: 'New',
    tasks: 'Activities',
    none: 'None',
    columns: 'Columns',
    fields: 'Fields',
    'switch-account': 'Switch account',
    'save-and-continue': 'Save and continue',
    skip: 'Skip',
    finish: 'Finish',
    yes: 'Yes',
    'owned-by': 'Owned by',
    'no-owner-set': 'No project lead set',
    owner: 'Lead',
    description: 'Description',
    'general-details': 'General details',
    'link-to-metrics': 'Link to kpis',
    'set-targets': 'Set project targets',
    'oh-no': 'Oh no!',
    resources: 'Resources',
    'goals-n-metrics': 'Strategic objectives & KPIs',
    activity: 'Activity',
    project: 'Project',
    summary: 'Executive summary',
    'paid-feature': 'Paid feature',
    'send-invites': 'Send invites',
    'invite-members': 'Invite members',
    'invitations-sent-successfully': 'Invitations sent',
    adjustments: 'Adjustments',
    upgrade: 'Upgrade',
    'not-set': 'Not set',
    'submitted-by': 'Submitted by',
    'confirm-delete':
      'Are you sure you want to permanently delete the {resource_type}: {resource_name}',
    'knowledge-base': 'Knowledge Base',
    copy: 'Copy',
    artifact:
      '{num, plural, =0 {No Artifacts found} =1 {Artifact} other {Artifacts}}',
  },
  sorting: {
    'a-z': 'Sort A-Z',
    'z-a': 'Sort Z-A',
    'low-to-high': 'Low to High',
    'high-to-low': 'High to Low',
    'old-to-new': 'Oldest to Newest',
    'new-to-old': 'Newest to Oldest',
  },
  personals: {
    organisation: 'Company',
    'start-of-week': 'Start of week',
    name: 'name',
    account: 'User account',
    details: 'Details',
    abbreviation: 'abbreviation',
    unavailable: 'Unavailable',
    time: 'time',
    holidays: 'Holidays',
    other: 'Other',
    pto: 'Paid time off',
    sick_leave: 'Sick leave',
    total: 'Total',
    type: 'Type',
    duration: 'Timeline',
    flex: 'Operational flex',
  },
  'status-options': {
    draft: 'Concept',
    'draft-description':
      'Projects are still in concept phase, shaping the documentation and gathering feedback.',
    active: 'Under development',
    'active-description': 'Projects currently have a team working on them.',
    ready: 'Ready to build',
    'ready-description':
      'Projects have their documentation ready and that will start as soon as they get priority and a team is available.',
    completed: 'Operational',
    'completed-description': 'Projects are operational.',
    parked: 'On hold',
    'parked-description':
      'Projects have actively been halted or stopped before they were operational with the intention to work on them later. ',
    archived: 'Inactive',
    'archived-description': "All Projects don't fit the list above.",
    discovery: 'Due diligence',
    'discovery-description':
      'It has been decided to spend time to investigate the feasibility and RETURN ON INVESTMENT of the Project',
    planning: 'Shovel ready',
    'planning-description':
      'Projects have passed the validity/feasibility assessment stage, and the development of which is ready to be planned into weeks.',
    'soft-delete': 'Archived',
    'soft-delete-description':
      'Initiatives are no longer being worked on and are soft deleted',
  },
  'source-options': {
    vision: 'Strategic vision',
    'vision-description':
      'Projects stem from the mission, strategic vision and investment strategy of the company, but that are not directly placeable in any of the other categories.',
    'customer-request': 'Investor',
    customer_request: 'Investor',
    customer: 'Investor',
    'customer-request-description':
      'Projects started as a result of one more requests or problems of current investors.',
    'customer-short': 'Investor',
    operations: 'Operations & maintenance',
    'operations-short': 'Operations & maintenance',
    'operations-description':
      'Projects started as a result of operational & maintenance activities. Including scale, performance, technical upgrades and automation. Generally holds a lot of technical topics.',
    other: 'Other',
    'other-description': "Projects don't fall in any of the above categories.",
    'not-classified': 'Not classified',
    flow: 'Op. Flex',
    explanation:
      'The project source defines where your Projects derive from. By defining the source for the Projects you can make more informed decisions during your pipeline prioritisation.',
  },
  help: {
    title: 'help',
    'contact-support': 'Contact support',
    'help-and-feedback': 'Help & Feedback',
    feedback: 'Submit feedback',
    'help-center': 'Help center',
  },
  dashboards: {
    title: 'Overview dashboard',
    'return-on-investment': 'Return on capital investment',
    'nav-description': "How's your pipeline looking?",
    roi: 'Projects',
    overview: 'Summary',
    'time-to-value': 'Time to value',
    loading: 'Loading',
    expected: 'Expected',
    investment:
      '{num, plural, =0 {Capital investment} =1 {Capital investment} other {Capital investments}}',
    returns:
      '{num, plural, =0 {Return on investment} =1 {Return on investment} other {Returns}}',
    impact: 'Financial impact',
    all: 'All {initiatives}',
    'roi-explanation':
      'By glancing over the capital investment, expected returns and the expected financial impact you can easily spot the big fish in the pond. These might require a bit more attention.',
    product: 'Portfolio',
    'leverage-metric':
      '{numMetrics, plural, =0 {No metric} =1 {Leverage metric} other {Leverage kpis}}',
    'leverage-metric-explanation':
      'There are two ways to create this metric visualisation. You can either contact us to connect your existing tools or get this out of the box by using the Scaleforce app. What would you like to do? ',
    start: 'Start with',
    'capacity-overview': 'Capacity summary',
    'select-roadmap': 'Select Pipeline',
    teams: '{num, plural, =0 {team} =1 {team} other {teams}}',
    roles: '{num, plural, =0 {Function} =1 {Function} other {Functions}}',
    'team-capacity': 'Capacity per team',
    'team-capacity-explanation': '',
    'initiatives-explanation':
      'A list of all Projects that belong to the selected pipeline. Team Resource allocation represents total team resource allocation for this project.',
    'role-capacity': 'Capacity per Function',
    'role-capacity-explanation': '',
    weekly: 'Weekly reporting',
    'weekly-capacity':
      'Weekly reporting capacity needed for Development planned {initiatives}',
    'weekly-capacity-explanation':
      'Summary of average capacity needed for all Development planned {initiatives}. Only {initiatives} with a start and commercial operation date are represented.',
    'weekly-indicators': 'Weekly reporting indicators',
    'since-last-week': 'Since last week',
    'since-last-month': 'Since last month',
    'releases-time-to-value': 'Releases & Time to First Value (demo)',
    'custom-metric': 'Your custom metric',
  },
  table: {
    title: 'Title',
    edit: 'Edit',
    delete: 'Delete',
  },
  _goals: {
    title:
      '{num, plural, =0 {Strategic objective} =1 {Strategic objective} other {Strategic objectives}}',
    add: 'New {goal}',
    edit: 'Edit {goal}',
    heading: 'Investment {goal}',
    'nav-description': 'What are your investment strategy drivers?',
    'confirm-delete':
      'Are you sure you want to permanently delete the strategic objective: {goal_name}?',
    'linked-to-attribute': 'Linked to {attribute}',
    'no-goals': 'There are no {goals}',
    'empty-state-description': 'You can set a description by',
    'editing-the-goal': 'editing the {goal}',
    'link-initiatives': 'You can link {initiatives} to this {goal} from the',
    overview: 'summary',
    'sub-goals': 'Substrategic objectives',
    'cannot-link-to-child':
      "You can't link to substrategic objectives of the strategic objective you are editing",
    status: {
      title: 'Development status',
      true: 'In status',
      false: 'Not under development',
    },
    wizard: {
      'title-label': 'What is the {goal}?',
      'link-to-goal': 'Link to other {goals}',
      'link-to-parent-goal': 'Link to parent {goal}',
    },
    table: {
      title: 'Title',
      edit: 'Edit',
      delete: 'Delete',
    },
  },
  _initiatives: {
    title:
      '{num, plural, =0 {No Project to display} =1 {Project} other {Projects}}',
    'nav-description': 'Prepare {initiatives}',
    pm: '{num, plural, =0 {Lead} =1 {Lead} other {Leads}}',
    'product-manager': 'Lead',
    effort: 'Resource allocation',
    uncertainty:
      '{num, plural, =0 {Risk factor} =1 {Risk factor} other {Risk factors} }',
    impact: 'Financial impact',
    teams: '{num, plural, =0 {Team} =1 {Team} other {Teams}}',
    roles: '{num, plural, =0 {Function} =1 {Function} other {Functions}}',
    'starting-week': 'Starting week',
    duration: 'Timeline',
    priority: 'Priority',
    progress: 'Status',
    'progress-nav-description':
      'Get an summary of how the Projects in your pipeline are running.',
    themes: '{num, plural, =0 {Tag} =1 {Tag} other {Tags}}',
    goals:
      '{num, plural, =0 {Strategic objective} =1 {Strategic objective} other {Strategic objectives}}',
    add: 'New {initiative}',
    filters: 'Search filters',
    'clear-attribute': 'Clear {attribute}',
    source:
      '{num, plural, =0 {Project source} =1 {Project source} other {Project sources}}',
    status: 'Development status',
    'back-of-napkin':
      '{num, plural, =0 {Financial impact} =1 {Financial impact} other {Financial impact}}',
    investment:
      '{num, plural, =0 {Capital investment} =1 {Capital investment} other {Capital investments}}',
    returns:
      '{num, plural, =0 {Return on investment} =1 {Return on investment} other {Returns}}',
    'person-weeks': 'Team member-weeks',
    details: 'Details',
    description: 'Description',
    abbreviation: 'abbreviation',
    'no-records': 'No record',
    update:
      '{num, plural, =0 {progress update} =1 {progress update} other {progress updates}}',
    updates_on_track: 'On Track',
    updates_needs_review: 'Needs attention',
    updates_at_risk: 'At risk',
    updates_delayed: 'Delayed',
    'updates_no-records': 'No record',
    'reported-health-title': 'What is the status of this {initiative}?',
    'reported-health-description':
      'Mark the status of this {initiative} by selecting the number of dots to fill in',
    'group-by': 'Group by',
    'display-columns': 'Display columns',
    roadmap: '{num, plural, =0 {Pipeline} =1 {Pipeline} other {Pipelines}}',
    weeks: '{num, plural, =0 {No weeks} =1 {Week} other {Weeks}}',
    strategic: '',
    'go-to-bon': 'Go to {bon} calculator',
    calculate: 'Calculate',
    'general-details': 'general-details',
    planning: 'Development planning',
    'planning-link': 'Development plan',
    'document-link': 'Document repository',
    people: 'Team members',
    'select-pm': 'Assign a lead',
    'select-goal': 'Select a strategic objective',
    'select-teams': 'Select teams',
    strategy: 'Investment strategy',
    document: 'Documentation',
    'copy-link': 'Copy {initiative} link',
    settings: 'Configuration',
    'initiative-link-copied': '{initiative} link copied to clipboard!',
    'roi-strategy': 'RETURN ON INVESTMENT Investment strategy',
    wfa: 'Blockers',
    'waiting-for-answers': 'Blockers',
    tickets: 'Tickets',
    closed: 'closed',
    open: 'open',
    'no-updates': 'No progress updates',
    'context-to-update': 'Please add some context to your update here',
    'version-history': 'Document versions',
    'load-template': 'Load template',
    'document-linked':
      'Please note that you already have documentation linked to this project',
    'go-to-doc': 'See documentation',
    versions: 'Versions',
    'current-version': 'Current version',
    restore: 'Restore',
    'read-only-mode': 'This is a read only saved version.',
    'version-restored': 'Version restored successfully!',
    'start-here':
      '👇 Start your documentation here or click the 📋 button on the top right to load our default template',
    'planning-linked':
      'Please note that you already have a development planning linked to this Project',
    'go-to-planning': 'See development planning',
    person:
      '{num, plural, =0 {Team member} =1 {Team member} other {Team members}}',
    'weekly-goals': 'Weekly reporting strategic objectives',
    'workstream-name': 'Name',
    'workstream-placeholder': 'Enter the title of your list',
    workstream: '{num, plural, =0 {Phase} =1 {Phase} other {Phases}}',
    'timeline-alert':
      '<p>In order to render Projects on a schedule view you need to indicate a <strong>start date</strong> and <strong>timeline</strong></p>',
    'set-document':
      'You can set a documentation link at the configuration page',
    'set-planning':
      'Do you do your development planning in another tool? You can set a Development plan in the side-panel.',
    'team-settings-relocation':
      'Teams can now be set by adding them to your estimations under the Financial impact tab',
    'planned-initiatives': 'Development planned {initiatives}',
    'exit-warning-modal': {
      title: 'Save changes?',
      explanation:
        'This project has unsaved changes and you are about to go to another page. Before leaving tell us what you would like to do with your changes.',
    },
    table: {
      title: 'Title',
      edit: 'Edit',
      delete: 'Delete',
    },
    'empty-state': 'This {initiative} has no {item}',
    'no-activity': 'There is no activity',
    'upgrade-snippet':
      'There is a more powerful version of this snippet available. Would you like to try it out?',
  },
  metrics: {
    title: 'KPIs',
    targets: 'Targets',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    unknown: 'N/A',
    description:
      'The completion rate is calculated from the amount of typed words',
  },
  _scenarios: {
    title: '{num, plural, =1 {Balance} other {Balances}}',
    'nav-description':
      'Where should resource allocation go? Strategic vision, Investors or Operations & maintenance?',
    create: 'New {scenario}',
    'no-scenarios':
      'Please click on "+ New {scenario}" to create your first {scenario}',
    'summary-investment-strategy':
      'Executive summary of Capital investment Investment strategy',
    to: 'to',
    investment:
      '{num, plural, =0 {Capital investment} =1 {Capital investment} other {Capital investments}}',
    returns:
      '{num, plural, =0 {Return on investment} =1 {Return on investment} other {Returns}}',
    impact: 'Financial impact',
    initiatives:
      '{num, plural, =0 {No Project to display} =1 {Project} other {Projects}}',
    budget: 'Total budget',
    percentage: 'Percentage',
    percent: 'Percent',
    'starting-date': 'Start date',
    'ending-date': 'Commercial operation date',
    total: 'Total',
    'planning-limit': 'Development planning limit',
    'capacity-allocation': 'Capacity allocation',
    distribution: 'Allocation',
    'size-limit': 'Size limit of {initiative} (pw)',
    min: 'Minimum',
    max: 'Maximum',
    pw: 'pw',
    euros: 'Dollars',
    'investment-in-initiatives': '{investment} in Projects',
    flow: 'Flow',
    'number-of-initiatives-to-run': 'Number of {initiative} to run',
    'investment-sizes-in-euros':
      '{investment} sizes per project in terms of dollars',
    'advised-range': 'Advised range',
    'investment-sizes-in-pw':
      '{investment} sizes per project in terms of team member weeks of resource allocation',
    'lower-limit': 'Lower limit',
    'upper-limit': 'Upper limit',
    strategy: 'Investment strategy',
    table: {
      title: 'Title',
      edit: 'Edit',
      delete: 'Delete',
    },
  },
  financials: {
    title: 'Economics',
    'nav-description':
      'What sets the costs, productivity and financial impact of engineering?',
    fte: 'FULL-TIME EQUIVALENT',
    effort: 'Resource allocation',
    'full-time-equivalent': 'Full-time-equivalent',
    'fte-explanation':
      'Full-time-equivalent, measures the total amount of full-time employees working at any one company. It is a way of adding up the hours of full-time, part-time and various other types of employees into measurable "full-time" units.',
    'person-weeks': 'Team member-weeks',
    'person-weeks-full': 'Price-per-team member-week',
    'ppw-explanation':
      'The capital investment calculation uses an average price-per-team member-per-week.',
    period: 'Period',
    'global-values': 'global values',
    'back-of-napkin':
      '{num, plural, =0 {Financial impact} =1 {Financial impact} other {Financial impact}}',
    bon: 'BC',
    explanation:
      'The following attributes are used in the calculation of the {bon}. To edit those values please <a class=\'underline\' href="mailto:project team@getscaleforce.com">contact</a> the Scaleforce project team.',
    'bon-definition':
      'The {bon} is a simple way of checking if an idea is a sound investment strategy opportunity.',
    'bon-uses':
      "Creating a {bon} for projects will help you evaluate a project's potential and make informed decisions regarding priorities.",
    horizon: 'Investment horizon',
    'horizon-explanation':
      'The investment horizon is the limit in time you set to calculate your returns for. Example investment horizon values are 12 or 18 months. When you sell 12 month contracts it makes sense to set your investment horizon at 12 months',
    'investment-horizon': 'Investment horizon',
    engineering: 'Engineering',
    clv: 'CV',
    'customer-lifetime-value': 'Investor value',
    'new-customer-value': 'New investor value',
    confidence: 'confidence level',
    'confidence-level': '{confidence} level',
    'confidence-level-explanation':
      'This multiplier adjusts the {type} estimation with the level of certainty.',
    investment:
      '{num, plural, =0 {Capital investment} =1 {Capital investment} other {Capital investments}}',
    returns:
      '{num, plural, =0 {Return on investment} =1 {Return on investment} other {Returns}}',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    confirmed: 'Confirmed',
    calculation: 'calculation',
    'empty-field': 'Empty field',
    templates: 'Templates',
    total: 'Total',
    'new-customer':
      '{num, plural, =0 {New investor} =1 {New investor} other {New investors}}',
    customers: '{num, plural, =0 {investor} =1 {investor} other {investors}}',
    'up-sell': 'Expansion',
    'saved-ftes': 'Saved FULL-TIME EQUIVALENT',
    months: 'Months',
    'within-horizon': 'within investment horizon',
    ppw: 'PPW',
    'upsell-title': 'Expansion value',
    'upsell-explanation':
      'Expansion is a sales investment strategy where investors are offered a more feature rich version of the project portfolio at a higher price point. The expansion value is the difference between what the investor is paying now, and what the investor will pay with the new feature included.',
    'clv-definition':
      'Investor Lifetime Value is the predicted net value a company will gain from a investor over the course of their relationship and can be calculated in various ways. To start we recommend you use the following calculation:',
    'clv-howto':
      ' Divide your yearly revenue by the amount of investors you have. Adjust it to fit your investment horizon if needed.',
    'number-of': 'number of',
    weeks: '{num, plural, =0 {No weeks} =1 {Week} other {Weeks}}',
    'price-of': 'Price of',
    person:
      '{num, plural, =0 {Team member} =1 {Team member} other {Team members}}',
    'customer-values': {
      title: 'Investor values',
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      custom: 'Custom',
    },
  },
  roles: {
    title: '{num, plural, =0 {Function} =1 {Function} other {Functions}}',
    'nav-description': 'Manage your {roles}',
    add: 'New {role}',
    'group-by': 'Group by',
    person:
      '{num, plural, =0 {Team member} =1 {Team member} other {Team members}}',
    'no-roles': 'There are no functions in your company',
    name: 'Name',
    fte: 'FULL-TIME EQUIVALENT',
    'capacity-fte': 'Capacity (FULL-TIME EQUIVALENT)',
    edit: 'Edit',
    delete: 'Delete',
    'create-role': 'Create {role}',
    'edit-role': 'Edit {role}',
    'name-placeholder': 'Enter function name',
    'name-cannot-be-blank': 'Function name cannot be blank',
    hint: 'Please fill in a name.',
    'ftes-placeholder':
      'How many FULL-TIME EQUIVALENT can fulfill this function?',
    'choose-people': 'Who can fulfill this function?',
    'no-people': 'No team member chosen',
    'do-later': 'Feel free to do this later',
    'empty-roles': 'Empty functions',
  },
  agents: {
    title: '{num, plural, =0 {No agents} =1 {Agent} other {Agents}}',
    provider: 'Provider',
    create: 'Create Agent',
    edit: 'Edit Agent',
  },
  people: {
    title:
      '{num, plural, =0 {Team member} =1 {Team member} other {Team members}}',
    'no-active-people':
      'There are no under development team members in your company',
    'no-inactive-people': 'There are no inactive team members in your company',
    add: 'New {person}',
    'group-by': 'Group by',
    team: '{num, plural, =0 {Team} =1 {Team} other {Tams}}',
    roles: '{num, plural, =0 {Function} =1 {Function} other {Functions}}',
    name: 'Name',
    active: 'Under development',
    inactive: 'Inactive',
    edit: 'Edit',
    'edit-person': 'Edit {person}',
    'name-placeholder': 'John Doe',
    'name-hint': 'Please fill in a name',
    abbreviation: 'Abbreviation',
    'abbreviation-placeholder': 'JD',
    'abbreviation-hint': 'Please fill in a two letter abbreviation',
    status: 'Development status',
    'form-choose-teams': 'What team(s) does this team member belong to?',
    'form-choose-roles': 'What function(s) does this user fulfill?',
    'form-no-teams': 'No team(s) chosen',
    'form-no-roles': 'No function(s) chosen',
    'nav-description':
      'Administer the {people} contributing to Portfolio & Engineering',
  },
  themes: {
    title: '{num, plural, =0 {Tag} =1 {Tag} other {Tags}}',
    'nav-description': 'Group {initiatives} that belong together.',
    add: 'Add {theme}',
    edit: 'Edit {theme}',
    color: 'Color',
    'no-color': 'No color selected',
    table: {
      title: 'Title',
      edit: 'Edit',
      delete: 'Delete',
    },
  },
  idea: {
    title: '{num, plural, =0 {No ideas} =1 {Idea} other {Ideas}}',
    deadline: 'Deadline',
    'revenue-existing': 'Revenue existing',
    'revenue-potential': 'Revenue potential',
    status: {
      new: 'New',
      parked: 'Parked',
      long_list: 'Long list',
      short_list: 'Short list',
      incomplete: 'Incomplete',
      in_development: 'In development',
      in_review: 'In review',
      done: 'Done',
    },
  },
  department: {
    title:
      '{num, plural, =0 {No Department to display} =1 {Department} other {Departments}}',
    create: 'Create Department',
    edit: 'Edit Department',
  },
  area: {
    title:
      '{num, plural, =0 {No Product modules to display} =1 {Product module} other {Product modules}}',
    create: 'Create Product module',
    edit: 'Edit Product module',
  },
  customer: {
    title:
      '{num, plural, =0 {No Customer to display} =1 {Customer} other {Customers}}',
    create: 'Create Customer',
    edit: 'Edit Customer',
  },
  lists: {
    workstream: 'List',
    'add-item': 'Add {item}',
    'edit-item': 'Edit {item}',
    'uncertainty-placeholder': 'Which are your big unknowns and risk factors?',
    'wfa-placeholder': 'What are your questions outside of the team?',
    'questions-placeholder': 'Anything to ask or share with the team?',
    'lessons-learned-placeholder': 'What is your lesson learned for the day?',
    'tfo-placeholder': 'What do you want to do today?',
    questions: 'Questions/FYI',
    'lessons-learned': 'Lessons Learned',
    'to-figure-out': 'To do',
    comments:
      '{num, plural, =0 {no comments} =1 {# comment} other {# comments}}',
  },
  _teams: {
    add: 'Add {team}',
    'nav-description': 'Manage your {teams}',
    title: '{num, plural, =0 {Team} =1 {Team} other {Teams}}',
    name: 'Name',
    'name-placeholder': 'Super Mario',
    'name-hint': 'Please fill in a name. ',
    'name-error': 'Team name cannot be blank',
    person:
      '{num, plural, =0 {Team member} =1 {Team member} other {Team members}}',
    'group-by': 'Group by',
    'capacity-fte': 'Capacity (FULL-TIME EQUIVALENT)',
    lists: 'lists',
    'check-in': 'Status update',
    default: 'Default',
    'default-list-explanation':
      'Your Status update always contains the following lists that guide you.',
    'optional-list-explanation':
      'If you want to keep risk factors and blockers front and center, you can activate them in your Status update in the list below.',
    members: '{num, plural, =0 {member} =1 {member} other {members}}',
    'auto-archive-time': 'Auto filing time',
    'auto-archive-description':
      'Here you can set the auto filing time for the company. This means that on daily basis, all the checked items of the Status update page will be inactive at the selected time.',
    'time-selection': 'Time selection',
    'time-zone': 'Time zone',
    am: 'AM',
    pm: 'PM',
    'archive-team': 'Archive team',
    'team-status': 'Team development status',
    'team-status-description':
      'If the team is inactive, all the team relevant information is still available from the inactive teams list. Once the team is inactive it will no longer be displayed in the pipeline or in team selection menus.',
    'archived-success': 'Team is inactive successfully',
    'restored-success': 'Team is restored successfully',
    'team-members': 'Team members',
    'add-member': 'Add member',
    remove: 'Remove member',
    'active-teams': 'Under development',
    'inactive-teams': 'Inactive',
    'no-active-teams': 'There are no under development Teams.',
    'no-inactive-teams': 'There are no inactive Teams.',
    'no-members': 'No members',
    restore: 'Restore',
    link: '{num, plural, =0 {Link} =1 {Link} other {Links} }',
    uncertainty:
      '{num, plural, =0 {Risk factor} =1 {Risk factor} other {Risk factors} }',
    'waiting-for-answers': 'Blockers',
    questions: 'Questions/FYI',
    'lessons-learned': 'Lessons Learned',
    'to-figure-out': 'To do',
    settings: 'Configuration',
    'timezone-placeholder': 'Search for city',
  },
  roadmap: {
    title: '{num, plural, =0 {Pipeline} =1 {Pipeline} other {Pipelines}}',
    'roadmap-strategies': 'Portfolio Pipeline',
    'nav-description': 'Create and View pipelines',
    add: 'Add {roadmap}',
    new: 'New Pipeline',
    'edit-roadmap': 'Edit Pipeline',
    'roadmap-link-copied': 'Pipeline link copied to clipboard!',
    overplanned: 'Overplanned',
    planned: 'Development planned',
    total: 'Total',
    uncertainty:
      '{num, plural, =0 {Risk factor} =1 {Risk factor} other {Risk factors} }',
    available: 'Available',
    'click-to-assign': 'Click to assign project',
    capacity: 'Capacity',
    table: {
      title: 'Title',
      edit: 'Edit',
      delete: 'Delete',
    },
    'start-date': 'Start date',
    'end-date': 'Commercial operation',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    roi: 'Projects',
    'required-spot': 'Required spot',
    'optional-spot': 'Optional spot',
    'not-recommended': 'Not recommended',
    'is-recommended': 'Recommended',
    'title-placeholder': 'Enter pipeline title here',
    'strategy-lens': 'Investment strategy Lens',
    'capacity-nav-description':
      'Understand the capacity allocation and limits of your pipelines.',
    progress: 'status',
    'confirm-delete':
      'Are you sure you want to permanently delete the pipeline: {roadmap_name}?',
  },
  nav: {
    dashboards: {
      self: 'Overview dashboard',
      dashboard: 'Overview dashboard',
      roi: 'Projects',
      'time-to-value': 'Time to value',
      capacity: 'Capacity',
    },
    capacity: {
      self: 'Capacity',
      teams: '{num, plural, =0 {Team} =1 {Team} other {Teams}}',
      roles: '{num, plural, =0 {Function} =1 {Function} other {Functions}}',
      weeks: '{num, plural, =0 {No weeks} =1 {Week} other {Weeks}}',
    },
    strategy: {
      self: 'Investment strategy',
      overview: 'Summary',
      scenarios: '{num, plural, =1 {Balance} other {Balances}}',
      'investment-scenarios': {
        self: '{num, plural, =1 {Balance} other {Balances}}',
        'investment-scenario': {
          edit: 'Edit',
          view: 'View',
        },
      },
      goals:
        '{num, plural, =0 {Strategic objective} =1 {Strategic objective} other {Strategic objectives}}',
      financials: 'Economics',
    },
    roadmap: {
      self: '{num, plural, =0 {Pipeline} =1 {Pipeline} other {Pipelines}}',
      overview: 'Summary',
      radar: 'Radar',
      timeline: 'Schedule view',
      'now-next-later': 'Now-Next-Later',
      concept: 'Concept',
      strategy: {
        self: '{num, plural, =0 {Pipeline} =1 {Pipeline} other {Pipelines}}',
        create: 'Create',
        roadmap: {
          grid: 'Status',
          lanes: 'Pipeline view',
          timeline: 'Schedule view',
        },
      },
    },
    backlog: {
      self: 'Backlog',
      overview: 'Summary',
      initiatives: {
        self: '{num, plural, =0 {No Project to display} =1 {Project} other {Projects}}',
        initiative: {
          self: 'Project',
          document: 'Documentation',
          bon: '{num, plural, =0 {Financial impact} =1 {Financial impact} other {Financial impact}}',
          uncertainties:
            '{num, plural, =0 {Risk factor} =1 {Risk factor} other {Risk factors} }',
          wfas: 'Blockers',
          weeks: '{num, plural, =0 {No weeks} =1 {Week} other {Weeks}}',
          workstreams: '{num, plural, =0 {Phase} =1 {Phase} other {Phases}}',
          planning: {
            self: 'Development planning',
            workstreams: {
              self: 'Activities',
              workstream: {
                archive: 'Historical records',
              },
            },
            weeks: 'Weeks',
          },
          settings: 'Configuration',
        },
      },
      'business-cases': 'Financial impact',
    },
    operations: {
      self: 'Operations & maintenance',
      overview: 'Summary',
      'check-ins': 'Status update-ins',
      planning: 'Development planning',
      people: {
        self: 'Team members',
        create: 'Create',
        active: 'Under development',
        inactive: 'Inactive',
      },
      roles: {
        self: 'Functions',
        create: 'Create',
      },
      teams: {
        self: 'Teams',
        active: 'Under development',
        archived: 'Inactive',
        team: {
          settings: 'Configuration',
          'check-in': {
            self: 'Status update',
            archive: {
              questions: 'Questions',
              lls: 'Lessons Learned',
              tfos: 'To-Dos',
              uncertainties: 'Risk factors',
              wfas: 'Blockers',
            },
          },
        },
      },
    },
    settings: {
      self: 'Configuration',
      organisation: 'Company',
      account: 'User account',
    },
    progress: 'Status',
  },
  currency: {
    euro: '$',
    locale: 'en-US',
  },
  'four-o-four-messages': {
    heading: {
      'heading-1':
        "Why do you need to be extra nice to bananas? You don't want to hurt their peelings.",
      'heading-2':
        'What do you call it when a banana eats another banana. Canabananalism.',
      'heading-3':
        'How much time goes by between when you slip on a banana peel and when you hit the ground? A bananosecond',
    },
    'sub-heading': 'Do you want to talk about it? You can submit your feedback',
    'or-contact': 'or contact',
    here: 'here',
    support: 'support',
  },
  pages: {
    404: 'Not found',
    loading: 'Loading',
    account: 'User account',
    organisation: 'Company',
    operations: 'Operations & maintenance',
    weeks: 'Weeks',
    'investment-scenarios': '{num, plural, =1 {Balance} other {Balances}}',
    'investment-scenario': '{num, plural, =1 {Balance} other {Balances}}',
    backlog: 'Backlog',
    scenario: '{num, plural, =1 {Balance} other {Balances}}',
    scenarios: '{num, plural, =1 {Balance} other {Balances}}',
    view: 'View',
    dashboards: 'Overview dashboard',
    analytics: 'Analytics',
    roi: 'Projects',
    'time-to-value': 'Time to Value',
    'initiative-performance': 'Performance',
    'team-performance': 'Team performance',
    capacity: 'Capacity',
    settings: 'Configuration',
    'organisation-details': 'Company project details',
    'investment-strategy': 'Capital investment investment strategy',
    'business-cases': 'Investment strategy cases',
    themes: '{num, plural, =0 {Tag} =1 {Tag} other {Tags}}',
    goals: 'Strategic objectives',
    roadmap: 'Pipeline',
    table: 'Table',
    radar: 'Radar',
    'now-next-later': 'Now-Next-Later',
    'roadmap-strategy': 'Investment strategy Pipeline',
    'radar-concept': 'Radar Concept',
    timeline: 'Schedule view',
    'general-details': 'General details',
    'planning-and-people': 'Resource planning',
    strategy: 'Investment strategy',
    bookmarks:
      '{num, plural, =0 {Favorites} =1 {Favorites} other {Favorites} }',
    teams: 'Teams',
    team: 'Team',
    active: 'Under development',
    archived: 'Inactive',
    create: 'Create',
    'check-in': 'Status update',
    archive: 'Historical records',
    uncertainties: 'Risk factors',
    'waiting-for-answers': 'Blockers',
    questions: 'Questions',
    'lessons-learned': 'Lessons learned',
    'to-figure-outs': 'To dos',
    initiatives: 'Projects',
    initiative: 'Project',
    planning: 'Development planning',
    workstreams: 'Activities',
    workstream: 'List',
    'back-of-a-napkin':
      '{num, plural, =0 {Financial impact} =1 {Financial impact} other {Financial impact}}',
    document: 'Documentation',
    'weekly-goals': 'Development planning',
    current: 'Summary',
    list: 'List',
    financials: 'Economics',
    people: 'Team members',
    roles: 'Functions',
    role: 'Function',
    edit: 'Edit',
    login: 'Login',
    person: 'Team member',
    inactive: 'Inactive',
    progress: 'Status',
    grid: 'Status',
    lanes: 'Pipeline view',
  },
};
